import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { StyledLink, StyledAIButton } from "./Login.styled";

import { Logo, PageTitle } from "@components/common";
import { LoginForm } from "@components/form";
import { Box, Divider, Grid, Paper, Stack, Typography } from "@components/base";

const Login: FC = () => {
  const { t } = useTranslation();

  return (
    <Box component="main" pt={6}>
      <PageTitle title={t("auth.login")} />

      <Container maxWidth="sm">
        <Paper>
          <Stack direction="column" p={4} rowGap={3}>
            <Stack alignItems="center" direction="column" rowGap={2}>
              <Link to="/login">
                <Logo height={80} width={80} type="green0meter-with-csob" />
              </Link>

              <Typography variant="title">{t("auth.login")}</Typography>
              <Typography variant="text">{t("auth.signIn")}</Typography>
            </Stack>

            <LoginForm />

            <Grid container spacing={2} textAlign="center">
              <StyledLink to="/password-recovery">
                {t("auth.forgotPassword")}
              </StyledLink>
            </Grid>

            <Divider />

            <Grid container spacing={2} justifyContent="center">
              <Typography variant="subtitle2">{t("register.noAccount")}</Typography>
              <StyledAIButton
                href="https://outlook.office.com/book/GreenometerDemo@green0meter.com/s/p97N7SJa3k6_gWhf3qep8Q2"
                startIcon={<AutoAwesomeIcon fontSize="small" />}
                fullWidth
              >
                {t("account.featuresGetInTouchTitle")}
              </StyledAIButton>
            </Grid>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;
